import Icon from "components/Icon"
import { Column, Row } from "components/Layout"
import Loader from "components/Loader"
import { useNavigate } from "react-router-dom"

export function PrivacyPolicyPage() {
  const navigate = useNavigate()

  return (
    <Column style={{ height: '100%' }}>
      <Row align="ml" padding="1.5rem 1rem" gap="1rem">
        <Icon name="arrow-left" onClick={() => navigate(-1)} />
        <h3>Privacy Policy</h3>
      </Row>

      <div style={{ flex: 1, width: '100%', padding: '1rem', fontSize: 14 }}>
        <Loader />
      </div>
    </Column>
  )
}
